import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { VideoService } from '../../services/video.service';

@Component({
  selector: 'app-video-lectures',
  templateUrl: './video-lectures.component.html',
  styleUrls: ['./video-lectures.component.scss']
})
export class VideoLecturesComponent implements OnInit {

  @Input()  subject: any;
  
  videoList : any;
  isVideoDownlaoded : boolean =  false;

  constructor(private videoService : VideoService) { }

  ngOnInit() {
    //console.log(JSON.stringify(this.subject));
    this.getAllVideosList();
  }


  getAllVideosList(){
    let body = {"subject" : ""+this.subject.name};
    this.videoService.getAllVideosListInCategory(body).subscribe((resp : any) => {
      this.onVideoListSucess(resp);
      }, (err) => {
    // Unable to log in
          this.onVideosListError(err);    
    });
  }



  onVideoListSucess(resp : any){
    this.videoList = resp;
    this.isVideoDownlaoded = true;
  }

  onVideosListError(err : any){
    this.isVideoDownlaoded = false;
  }


}
